import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import Typography from "@shared/v2/Typography";

const OktaStatus = ({ accountId, userId }) => {
  const [oktaProfileUrl, setOktaProfileUrl] = useState(null);
  const [oktaStatus, setOktaStatus] = useState(null);
  const [statusLoading, setStatusLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`/support/accounts/${accountId}/users/${userId}/okta_status`)
      .then((response) => {
        setStatusLoading(false);

        setOktaStatus(response.data.okta_status);

        setOktaProfileUrl(response.data.okta_profile_url);
      })
      .catch(console.log);
  }, []);

  return (
    <div>
      <Typography variant="subtitle-m-bold">Okta Status:</Typography>
      {oktaStatus && <a href={oktaProfileUrl}>{oktaStatus}</a>}
      {!statusLoading && oktaStatus === null && <span>NO OKTA ACCOUNT FOR THIS USER</span>}
      {statusLoading && <span>Loading...</span>}
    </div>
  );
};

OktaStatus.propTypes = {
  accountId: PropTypes.number.isRequired,
  userId: PropTypes.number.isRequired,
};

export default OktaStatus;
